/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSnapshotResponse model module.
 * @module model/AqaSnapshotResponse
 * @version v0
 */
export default class AqaSnapshotResponse {
  /**
   * Constructs a new <code>AqaSnapshotResponse</code>.
   * @alias module:model/AqaSnapshotResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSnapshotResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSnapshotResponse} obj Optional instance to populate.
   * @return {module:model/AqaSnapshotResponse} The populated <code>AqaSnapshotResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSnapshotResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('snapshotId'))
        obj.snapshotId = ApiClient.convertToType(data['snapshotId'], 'String');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaSnapshotResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaSnapshotResponse.prototype.message = undefined;

/**
 * @member {String} snapshotId
 */
AqaSnapshotResponse.prototype.snapshotId = undefined;

/**
 * @member {Boolean} successful
 */
AqaSnapshotResponse.prototype.successful = undefined;

